import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: 'How much does heavy equipment transport cost?',
    a: 'Heavy haul costs typically range from $2 to $5 per mile depending on the weight and dimensions of your machinery, the distance, and the route. We provide transparent, all-inclusive quotes with zero hidden fees. Request a free quote today for exact pricing.'
  }, {
    q: 'How long does shipping heavy machinery take?',
    a: 'Transit times vary based on distance. Generally, a move under 1,000 miles takes 1-3 days, 1,000-2,500 miles takes 3-6 days, and cross-country heavy haul over 2,500 miles takes 6-8 days.'
  }, {
    q: 'Is my equipment insured during transport?',
    a: 'Yes, absolutely. Every heavy equipment transport we handle is fully covered by comprehensive cargo insurance from pickup to delivery, giving you complete peace of mind.'
  }, {
    q: 'How do I prep my machinery for transport?',
    a: 'You should secure all loose parts, lower all booms/buckets to the ground, disconnect batteries if necessary, and ensure the equipment is clean enough for a proper inspection. We will provide a full preparation checklist when you book.'
  }, {
    q: 'Can you move oversized loads and wide loads?',
    a: 'Yes, we specialize in oversized and overweight heavy hauling. We handle all necessary wide-load permits, route surveys, and escort vehicles required for safe delivery.'
  }, {
    q: 'Is a deposit or upfront payment required?',
    a: 'No! Unlike many bidding sites and brokers, we never ask for a deposit or upfront payment before we secure a driver for your heavy haul. You only pay once your transport is scheduled.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-47">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <div className="text-center mb-12" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-black text-brand-navy mb-4" data-id="element-50">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-slate-600" data-id="element-51">
            Everything you need to know about our heavy equipment hauling
            services.
          </p>
        </div>

        <div className="space-y-4" data-id="element-52">
          {faqs.map((faq, index) => <div key={index} className="border border-slate-200 rounded-xl overflow-hidden bg-slate-50" data-id="element-53">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-navy" aria-expanded={openIndex === index} data-id="element-54">
                <span className="font-bold text-brand-navy pr-4" data-id="element-55">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-56" />
              </button>
              <AnimatePresence data-id="element-57">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-58">
                    <div className="px-6 pb-5 text-slate-600 leading-relaxed" data-id="element-59">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}